module.exports = __webpack_public_path__ + "img/play.00d298cb.svg";